<template>
  <b-img v-if="canDisplayImage" :src="displaySrc"></b-img>

  <b-col v-else class="px-0">
    <b-skeleton-img></b-skeleton-img>
  </b-col>
</template>

<script>
import Upload from '@/models/Upload';

export default {
  props: {
    defaultSrc: {
      type: String,
      default: null
    },
    fileId: {
      type: [String, Number],
      default: null
    },
    public: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFetched: false,
      src: null
    };
  },

  computed: {
    displaySrc() {
      return this.src || this.defaultSrc;
    },
    canDisplayImage() {
      return this.fileId ? this.isFetched && this.src : this.defaultSrc;
    }
  },

  mounted() {
    if (this.fileId) {
      this.fetchImage();
    }
  },

  methods: {
    async fetchImage() {
      try {
        const { response } = await Upload.api()[
          this.public ? 'fetchPublicPresignedUrl' : 'fetchPresignedUrl'
        ](this.fileId);

        const { url } = response.data;

        if (!url) {
          throw new Error('Invalid presigned response, missing url field');
        }

        this.src = url;

        this.isFetched = true;
      } catch (error) {
        this.$emit('error', error);
      }
    }
  }
};
</script>
